// extracted by mini-css-extract-plugin
module.exports = {"teamName":"TheUpcomingSummerMatch_teamName_1twNG","fullTeamName":"TheUpcomingSummerMatch_fullTeamName_2ClDk","myPickText":"TheUpcomingSummerMatch_myPickText_1FONj"};